export default function($) {
  $('.animate-section').waypoint(function (direction) {
    $(this.element).addClass('animate-in');
  }, { offset: '80%' });
}
